module.exports = __webpack_public_path__ + "static/media/virtual2.ef52a1bf.png";